import { defineStore } from "pinia";

 
export const useCustomerStore = defineStore("customerStore", () => {

    const router = useRouter();

    async function getCustomerPaginate(filter){
        try {
         
          const data = await useNuxtApp().$apiAuth(`/api/customer/paginate`,{
            method: 'GET',
            params:{
              ...filter
            }
           })
                             
            return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
    
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }

      async function getLawyersPaginate(filter){
        try {
         
          const { data } = await useNuxtApp().$apiAxios.get(`/api/customer/lawyers/paginate`,{
            params:{
              ...filter
            }
           })
                             
            return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
    
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function storeCache() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/cache/set`,{
            method: 'GET',
            use: 'admin'
           })
                             
            return {
              success: data?.success,
              data: data?.data,
            };
           
        } catch (error) {
    
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function followCustomer(customerId) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/social/${customerId}/follow`,{
            method: 'POST',
            use: 'customer'
           })
                             
            return {
              success: true,
              data: data,
            };
           
        } catch (error) {
        return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       async function unfollowCustomer(customerId) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/social/${customerId}/unfollow`,{
            method: 'delete',
            use: 'customer'
           })
                             
            return {
              success: true,
              data: data,
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }

      async function followingCustomer(customerId) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/social/${customerId}/following`,{
            method: 'get',
            use: 'customer'
           })
                             
            return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function followersCustomer(customerId) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/social/${customerId}/followers`,{
            method: 'get',
            use: 'customer'
           })
                             
            return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getCacheItems() {
        try {
          const data = await useNuxtApp().$api(`/api/ad/cache/get`,{
            method: 'GET' 
           })
                             
            return {
              success: true,
              data: data?.data,
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       async function getCacheTopAd() {
        try {
          const { data } = await useNuxtApp().$apiAxios.get(`/api/ad/cache/top/get`)
                             
            return {
              success: true,
              data: data?.data,
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function updateCustomer(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/update`,{
            method: 'PUT', 
            use: 'admin',
            body:{
               ...customer
            }
           })
          
                     
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: null
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            errorValidation: error?.response?._data?.errors,
            data: null,
          };
        }
      }
      async function updateLawyerAdmin(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/customer/lawyer/update`,{
            method: 'PUT', 
            body:{
              id: customer.id,
              lawyer_person: customer.lawyer_person
            }
           })
        
            return {
              success: true,
              content: data?.customer,
              errorValidation: null
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            errorValidation: error?.response?._data?.errors,
            content: false,
          };
        }
      }
      async function updateBlockCustomer(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/customer/block/admin`,{
            method: 'PUT', 
            body:{
              id: customer.id,
              is_block: customer.is_block
            }
           })
        
            return {
              success: true,
              content: data?.success,
              errorValidation: null
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            errorValidation: error?.response?._data?.errors,
            content: false,
          };
        }
      }
      async function customerDelete(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/delete`,{
            method: 'DELETE', 
            body:{
              id: customer.id,
            }
           })
        
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: null
            };
        
        } catch (error) {
        
          return {
            success: false,
            status: error.response?.status,
            errorValidation: error?.response?._data?.errors,
            data: null,
          };
        }
      }
    return {
        getCustomerPaginate,
        getCacheItems,
        storeCache,
        updateCustomer,
        updateLawyerAdmin,
        updateBlockCustomer,
        customerDelete,
        getCacheTopAd,
        getLawyersPaginate,
        followCustomer,
        unfollowCustomer,
        followingCustomer,
        followersCustomer
         
    }
})
